export const BUSINESS_TYPES = [
	{ value: "hotel", label: "Hotel" },
	{ value: "motel", label: "Motel" },
	{ value: "extended_stay_hotel", label: "Extended Stay Hotel" },
	{ value: "budget_hotel", label: "Budget Hotel" },
	{ value: "inn", label: "Inn" },
	{ value: "hostel", label: "Hostel" },
	{ value: "resort_hotel", label: "Resort Hotel" },
	{ value: "vacation_home_rental_agency", label: "Vacation Home Rental Agency" },
	{ value: "cabin_rental_agency", label: "Cabin Rental Agency" },
	{ value: "short_term_apartment_rental_agency", label: "Short-Term Apartment Rental Agency" },
	{ value: "rv_park", label: "RV Park" },
	{ value: "campground", label: "Campground" },
	{ value: "personal_injury_attorney", label: "Personal Injury Attorney" },
	{ value: "workers_compensation_attorney", label: "Workers' Compensation Attorney" },
	{ value: "criminal_justice_attorney", label: "Criminal Justice Attorney" },
	{ value: "immigration_attorney", label: "Immigration Attorney" },
	{ value: "family_law_attorney", label: "Family Law Attorney" },
	{ value: "divorce_attorney", label: "Divorce Attorney" },
	{ value: "bankruptcy_attorney", label: "Bankruptcy Attorney" },
	{ value: "estate_planning_attorney", label: "Estate Planning Attorney" },
	{ value: "employment_attorney", label: "Employment Attorney" },
	{ value: "tax_attorney", label: "Tax Attorney" },
	{ value: "social_security_attorney", label: "Social Security Attorney" },
	{ value: "dentist", label: "Dentist" },
	{ value: "pediatric_dentist", label: "Pediatric Dentist" },
	{ value: "orthodontist", label: "Orthodontist" },
	{ value: "periodontist", label: "Periodontist" },
	{ value: "emergency_dental_service", label: "Emergency Dental Service" },
	{ value: "urgent_care_center", label: "Urgent Care Center" },
	{ value: "chiropractor", label: "Chiropractor" },
	{ value: "pain_management_physician", label: "Pain Management Physician" },
	{ value: "physical_therapy_clinic", label: "Physical Therapy Clinic" },
	{ value: "weight_loss_service", label: "Weight Loss Service" },
	{ value: "sleep_clinic", label: "Sleep Clinic" },
	{ value: "dermatologist", label: "Dermatologist" },
	{ value: "hvac_contractor", label: "HVAC Contractor" },
	{ value: "plumber", label: "Plumber" },
	{ value: "electrician", label: "Electrician" },
	{ value: "roofing_contractor", label: "Roofing Contractor" },
	{ value: "general_contractor", label: "General Contractor" },
	{ value: "foundation_repair_service", label: "Foundation Repair Service" },
	{ value: "fence_contractor", label: "Fence Contractor" },
	{ value: "water_damage_restoration_service", label: "Water Damage Restoration Service" },
	{ value: "pest_control_service", label: "Pest Control Service" },
	{ value: "garage_door_supplier", label: "Garage Door Supplier" },
	{ value: "solar_energy_contractor", label: "Solar Energy Contractor" },
	{ value: "pool_cleaning_service", label: "Pool Cleaning Service" },
	{ value: "furniture_store", label: "Furniture Store" },
	{ value: "auto_parts_store", label: "Auto Parts Store" },
	{ value: "used_car_dealer", label: "Used Car Dealer" },
	{ value: "vape_shop", label: "Vape Shop" },
	{ value: "pet_supply_store", label: "Pet Supply Store" },
	{ value: "cell_phone_store", label: "Cell Phone Store" },
	{ value: "mobile_phone_repair_shop", label: "Mobile Phone Repair Shop" },
	{ value: "jewelry_store", label: "Jewelry Store" },
	{ value: "organic_food_store", label: "Organic Food Store" },
	{ value: "medical_supply_store", label: "Medical Supply Store" },
	{ value: "indian_restaurant", label: "Indian Restaurant" },
	{ value: "pizza_restaurant", label: "Pizza Restaurant" },
	{ value: "fast_food_restaurant", label: "Fast Food Restaurant" },
	{ value: "cafe", label: "Cafe" },
	{ value: "bakery", label: "Bakery" },
	{ value: "ice_cream_shop", label: "Ice Cream Shop" },
	{ value: "juice_shop", label: "Juice Shop" },
	{ value: "beauty_salon", label: "Beauty Salon" },
	{ value: "nail_salon", label: "Nail Salon" },
	{ value: "hair_salon", label: "Hair Salon" },
	{ value: "spa", label: "Spa" },
	{ value: "massage_spa", label: "Massage Spa" },
	{ value: "tattoo_shop", label: "Tattoo Shop" },
	{ value: "marketing_agency", label: "Marketing Agency" },
	{ value: "real_estate_agency", label: "Real Estate Agency" },
	{ value: "property_management_company", label: "Property Management Company" },
	{ value: "accounting_firm", label: "Accounting Firm" },
	{ value: "insurance_agency", label: "Insurance Agency" },
	{ value: "it_support_service", label: "IT Support Service" },
	{ value: "software_company", label: "Software Company" },
	{ value: "website_designer", label: "Website Designer" },
	{ value: "business_consultant", label: "Business Consultant" },
	{ value: "auto_repair_shop", label: "Auto Repair Shop" },
	{ value: "auto_body_shop", label: "Auto Body Shop" },
	{ value: "car_wash", label: "Car Wash" },
	{ value: "car_detailing_service", label: "Car Detailing Service" },
	{ value: "towing_service", label: "Towing Service" },
	{ value: "barber_shop", label: "Barber Shop" },
	{ value: "dry_cleaner", label: "Dry Cleaner" },
	{ value: "flower_shop", label: "Flower Shop" },
	{ value: "day_care_center", label: "Day Care Center" },
	{ value: "music_school", label: "Music School" },
	{ value: "martial_arts_school", label: "Martial Arts School" },
	{ value: "pet_groomer", label: "Pet Groomer" },
	{ value: "veterinarian", label: "Veterinarian" },
	{ value: "logistics_service", label: "Logistics Service" },
	{ value: "security_guard_service", label: "Security Guard Service" },
	{ value: "locksmith", label: "Locksmith" },
	{ value: "painting_contractor", label: "Painting Contractor" },
	{ value: "landscaper", label: "Landscaper" },
	{ value: "lawn_care_service", label: "Lawn Care Service" },
	{ value: "gutter_cleaning_service", label: "Gutter Cleaning Service" },
	{ value: "house_cleaning_service", label: "House Cleaning Service" },
];

